import { useEffect } from 'react';

import {
  useGetInspectionTemplate,
  type UseGetInspectionTemplateResult,
} from 'react-hooks';

export type UseInspectionTemplateCustomizeRouteFetchResult = Pick<
  UseGetInspectionTemplateResult,
  'template' | 'loading' | 'error' | 'called'
>;

export function useInspectionTemplateCustomizeRouteFetch(
  channelId: string | undefined,
  templateId: string | undefined
): UseInspectionTemplateCustomizeRouteFetchResult {
  const {
    template,
    loading,
    error,
    fetchInspectionTemplate,
    called,
  } = useGetInspectionTemplate();

  useEffect(() => {
    if (!channelId || !templateId) {
      return;
    }

    const request = fetchInspectionTemplate({
      id: templateId,
      channelId,
    });

    request.catch(() => undefined);
  }, [channelId, templateId, fetchInspectionTemplate]);

  return {
    template,
    loading,
    error,
    called,
  };
}
